import React from "react";
import TableBase from "./Base";
import moment from "moment";

import { DATE_FORMAT_FRONTEND } from "../../constants";
import { getTranslation, humanizeText } from "../../utils/helper";

const PartnerCompaniesTable = ({ scrollHeight, actionWidth, withAction, setting, ...props }) => {
  const COLUMNS = [
    {
      title: getTranslation(setting, "Companies", "Company Name"),
      dataIndex: "name",
      fixed: true,
      width: 150,
    },
    {
      title: getTranslation(setting, "Companies", "Email"),
      dataIndex: ["companyAdmin", "email"],
      width: 150,
    },
    {
      title: getTranslation(setting, "Companies", "Created Date"),
      dataIndex: "createdAt",
      width: 150,
      render(value) {
        return value ? moment(value).locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND) : "";
      },
    },
    {
      title: getTranslation(setting, "Companies", "Branding"),
      dataIndex: "accountType",
      width: 150,
      render(value) {
        return (
          <span className={`table-status ${value}`}>{value === "DEFAULT" ? "Parcelizer" : humanizeText(value)}</span>
        );
      },
    },
    {
      title: getTranslation(setting, "Companies", "# of Drivers"),
      dataIndex: "totalOfDrivers",
      width: 150,
      render(value) {
        return value || 0;
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default PartnerCompaniesTable;
